/* Rozana Bazaar - cart drawer 'You might also like' prev/next arrows */
(function () {
  var css =
    '.drawer-recs-wrap{position:relative;}' +
    '.drc-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:28px;height:28px;border-radius:50%;border:1px solid #E4E2D8;background:#fff;color:#0B3D2E;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 3px 10px rgba(0,0,0,.18);transition:background .15s,color .15s;}' +
    '.drc-arrow:hover{background:#0B3D2E;color:#fff;}' +
    '.drc-arrow svg{width:14px;height:14px;}' +
    '.drc-prev{left:-10px;}.drc-next{right:-8px;}' +
    '.drc-arrow[hidden]{display:none;}';
  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function init() {
    var row = document.querySelector('.drawer-recs-row');
    if (!row || row.parentNode.classList.contains('drawer-recs-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'drawer-recs-wrap';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);

    function mk(cls, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'drc-arrow ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
      wrap.appendChild(b);
      return b;
    }
    var prev = mk('drc-prev', 'Previous product', 'M15 5l-7 7 7 7');
    var next = mk('drc-next', 'Next product', 'M9 5l7 7-7 7');

    function visibleCards() {
      return Array.prototype.filter.call(row.querySelectorAll('.drawer-rec-card'), function (c) { return c.style.display !== 'none'; });
    }
    function step() {
      var cs = visibleCards();
      return cs.length ? cs[0].offsetWidth + 10 : 0;
    }
    function update() {
      var cs = visibleCards();
      var max = row.scrollWidth - row.clientWidth;
      prev.hidden = cs.length < 2 || row.scrollLeft <= 4;
      next.hidden = cs.length < 2 || row.scrollLeft >= max - 4;
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    new MutationObserver(update).observe(row, { attributes: true, subtree: true, attributeFilter: ['style'] });
    setTimeout(update, 300);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
